import { css, jsx } from '@emotion/react';
import { useMemo } from 'react';
import { TagGroupContext, TagGroup, TagList } from 'react-aria-components';

const ChipListStyles = css({
  display: "flex",
  alignItems: "start",
  gap: "var(--zds-space-8)",
  flexWrap: "wrap"
});
const SelectionChipList = ({ "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, children, defaultSelectedKeys, items, onSelectionChange, selectedKeys, selectionMode, size = "small", variant = "primary" }) => {
  const contextValue = useMemo(() => ({
    selectionMode: selectionMode !== null && selectionMode !== void 0 ? selectionMode : void 0,
    size,
    variant
  }), [selectionMode, size, variant]);
  return jsx(
    TagGroupContext.Provider,
    { value: contextValue },
    jsx(
      TagGroup,
      { "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "data-zds": true, defaultSelectedKeys, onSelectionChange, selectedKeys, selectionMode },
      jsx(TagList, { css: ChipListStyles, "data-zds": true, items }, children)
    )
  );
};

export { SelectionChipList };
//# sourceMappingURL=SelectionChipList.es.js.map
